import { PropType, defineComponent } from 'vue'

import { CsCopyTextLink, CsModal } from '@sunrise/components'
import { useGlobalStore } from '@sunrise/shared'
import { MLM } from '@sunrise/tracking'

import { DecoratedContactDetails } from '../../ts/mapper/decoratedEstateDetailMapper.interface'
import { ActionIds } from '../../ts/tracking/mlmActionIds.enum'

import { ContactNumberType } from './MsDetailModalCall.enum'
import { buildMlmTrackingData } from './MsDetailModalCallTracking'

export default defineComponent({
    name: 'MsDetailModalCall',
    components: {
        CsCopyTextLink,
        CsModal,
    },
    props: {
        isVisible: {
            type: Boolean,
            required: true,
        },
        contact: {
            type: Object as PropType<DecoratedContactDetails>,
            required: true,
        },
        exposeeId: {
            type: Number,
            required: true,
        },
    },
    emits: ['closeModal'],
    setup(props, { emit }) {
        const requestContext = useGlobalStore().requestContext
        const currentUrl = requestContext?.url.href || ''

        function trackMlm() {
            const mlmTrackingData = buildMlmTrackingData(
                ActionIds.CALL_NUMBER_CLICK,
                'M_Immo_Detail',
                currentUrl,
                props.exposeeId,
            )
            MLM.trackClick(mlmTrackingData)
        }

        function emitClosedModalEvent() {
            emit('closeModal')
        }

        return {
            ContactNumberType,
            trackMlm,
            emitClosedModalEvent,
        }
    },
})
